/**
 * NPS Survey Question translation keys
 * Used to reference translation keys in widgets.json nps_survey.questions namespace
 */
export enum NpsSurveyQuestionKey {
    ServicePerformance = 'service_performance',
    Pricing = 'pricing',
    SchedulingCommunication = 'scheduling_communication',
    Professionalism = 'professionalism',
    Retention = 'retention',
}

/**
 * Default NPS survey question definition (without translated text)
 */
export interface INpsSurveyQuestionDefinition {
    nps_survey_question_id: number;
    translation_key: NpsSurveyQuestionKey;
    required: boolean;
}

/**
 * Default NPS survey questions configuration
 * Translation is applied at runtime using the translation_key
 */
export const DEFAULT_NPS_SURVEY_QUESTIONS: INpsSurveyQuestionDefinition[] = [
    {
        nps_survey_question_id: 1,
        translation_key: NpsSurveyQuestionKey.ServicePerformance,
        required: false,
    },
    {
        nps_survey_question_id: 2,
        translation_key: NpsSurveyQuestionKey.Pricing,
        required: false,
    },
    {
        nps_survey_question_id: 3,
        translation_key: NpsSurveyQuestionKey.SchedulingCommunication,
        required: false,
    },
    {
        nps_survey_question_id: 4,
        translation_key: NpsSurveyQuestionKey.Professionalism,
        required: false,
    },
    {
        nps_survey_question_id: 5,
        translation_key: NpsSurveyQuestionKey.Retention,
        required: false,
    },
];
